import { Component, EventEmitter, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { AveriasService } from '../servicios/averias.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import * as _ from 'lodash';
import { ClienteOperadoresAyudaPopupComponent } from '../cliente-operadores-ayuda-popup/cliente-operadores-ayuda-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription, timer } from 'rxjs';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';


@Component({
    selector: 'app-clientes-operadores',
    templateUrl: './clientes-operadores.component.html',
    styleUrls: ['./clientes-operadores.component.css'],
    standalone: true,
    imports: [DragDropModule, FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule,
       DropdownModule, MatCardModule, MatFormFieldModule, 
       MatInputModule, AngularSlickgridModule, NbTabsetModule, 
       MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
})
export class ClientesOperadoresComponent implements OnInit {
  @Output('cdkDragDropped') dropped: EventEmitter<CdkDragDrop<any>>;

  operadores = [];
  misOperadores = [];
  idCliente = 0;
  misOperadoresOriginales = [];
  durationInSeconds = 5;
  showSpinnerOperadores: boolean = false;
  showSpinnerMisOperadores: boolean = false;
  showSpinnerIcono: boolean = false;
  hideLists = false;
  disableMisOperadores: boolean = false;
  disableOperadores: boolean = false;
  timer: Observable<any>;
  subscription: Subscription;

  miOperadorSeleccionado;
  operadorSeleccionado;


  constructor(private srvAverias: AveriasService, private _snackBar: MatSnackBar,
    public dialog: MatDialog, private svcAnalytics: AnalyticsService) {
    this.idCliente = Number(localStorage.getItem('idCliente'))
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(ClienteOperadoresAyudaPopupComponent, {
      width: '600px', height: '263px'
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      //si son iguales no hacemos nada
    } else {
      if (event.previousContainer.id == "operadores") {
        //aca agregamos los items
        let idOperadorNew = this.operadores[event.previousIndex].value;
        this.altaOperadores(idOperadorNew);
      }
      else {
        //aca borramos los items
        let idOperadorDelete = this.misOperadores[event.previousIndex].value
        this.bajaOperadores(idOperadorDelete);
      }
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  ngOnInit(): void {
    this.getClientesOperadoresPorCliente();
    this.svcAnalytics.setAnalyticsPageView();
  }
  endDragOperadores(event) {

  }
  endDragMisOperadores(event) {

  }

  getOperadores() {
    this.showSpinnerOperadores = true;
    this.srvAverias.getOperadores().subscribe(resp => {
      var operadores = resp.content;
      var encontro;
      operadores.forEach(element => {
        encontro = this.misOperadores.find(n => n.id == element.id);
        if (encontro == undefined)
          this.operadores.push({ name: element.descripcion, value: element.id })
      });
      this.showSpinnerOperadores = false;
    }, error => {
      this.showSpinnerOperadores = false;
    })
  }
  getClientesOperadoresPorCliente() {
    this.showSpinnerMisOperadores = true;
    this.srvAverias.getClientesOperadoresPorCliente(this.idCliente).subscribe(resp => {
      var operadores = resp;
      operadores.forEach(element => {
        this.misOperadores.push({ name: element.descripcion, value: element.idClienteOperador, id: element.id })
        this.misOperadoresOriginales = this.misOperadores;
      });
      this.getOperadores();
      this.showSpinnerMisOperadores = false;
    }, error => {
      this.showSpinnerMisOperadores = false;
    })
  }
  altaOperadores(idOperador: number) {
    var obj = {
      idCliente: this.idCliente,
      idOperador: idOperador
    }
    this.showSpinnerIcono = true;
    this.srvAverias.altaClienteOperador(obj).subscribe(resp => {
      if (resp.status == 201) {
        this.openSnackBar("Datos asignados correctamente");
      }
      else {
        this.showSpinnerIcono = true;
        this.openSnackBar("Ha ocurrido un error al guardar los datos ❌");
      }
      this.timer = timer(2000);
      this.subscription = this.timer.subscribe(() => {
        this.showSpinnerIcono = false;
      });
    }, errors => {
      this.openSnackBar("Ha ocurrido un error al borrar los datos ❌");
      this.showSpinnerIcono = false;
    })
  }

  bajaOperadores(idOperador: number) {
    this.showSpinnerIcono = true;
    this.srvAverias.bajaClienteOperador(idOperador).subscribe(resp => {
      if (resp.status = 204) {
        this.openSnackBar("Datos eliminados correctamente");
      } else {
        this.openSnackBar("Ha ocurrido un error al borrar los datos ❌");
      }
      this.timer = timer(2000);
      this.subscription = this.timer.subscribe(() => {
        this.showSpinnerIcono = false;
      });
    }, errors => {
      this.openSnackBar("Ha ocurrido un error al borrar los datos ❌");
      this.showSpinnerIcono = false;
    })
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }




}
